// Global CSS. Order matters: bootstrap must load after App.css so it wins ties.
import "./styles/App.css";
import "./styles/pageTransition.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import { BrowserRouter } from "react-router-dom";

import MainLayout from "./layouts/MainLayout";

export default function App() {
  return (
    <BrowserRouter>
      <MainLayout />
    </BrowserRouter>
  );
}
